// componentes/TableHeader.js
import React from "react";
import { Grid, Typography } from "@mui/material";

const TableHeader = () => (
  <Grid container spacing={1} sx={{ mb: 0.5, px: 1 }}>
    <Grid item xs={2}>
      <Typography variant="subtitle2" fontWeight="bold">
        Cant.
      </Typography>
    </Grid>
    <Grid item xs={4}>
      <Typography variant="subtitle2" fontWeight="bold">
        Producto
      </Typography>
    </Grid>
    <Grid item xs={4}>
      <Typography variant="subtitle2" fontWeight="bold">
        Precio Unit.
      </Typography>
    </Grid>
    <Grid item xs={2}>
      <Typography variant="subtitle2" fontWeight="bold">
        Acciones
      </Typography>
    </Grid>
  </Grid>
);

export default TableHeader;